import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-combo-box',
    templateUrl: 'combo-box.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class ComboBoxComponent {
    constructor() {

    }
}
